import { __awaiter, __generator } from "tslib";
import { appendLoginHint, isValidUrl } from '@office-start/url-parser-utility';
import { launchUrlWrapper } from './launchUrlWrapper';
export function createNewClipchamp(createOptions, area, template) {
    return __awaiter(this, void 0, void 0, function () {
        var capabilities, identity, componentContext, userEntitlements, targetTab, newDocLinkTarget, url, referrerParam;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    capabilities = createOptions.capabilities, identity = createOptions.identity, componentContext = createOptions.componentContext, userEntitlements = createOptions.userEntitlements, targetTab = createOptions.targetTab, newDocLinkTarget = createOptions.newDocLinkTarget;
                    if (!identity || !componentContext || !userEntitlements) {
                        return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                    }
                    if ((identity === null || identity === void 0 ? void 0 : identity.isOrgId) && !template) {
                        referrerParam = area ? "&referrerScenario=".concat(area) : '';
                        url = "".concat(userEntitlements.OneDriveResourceId, "/_layouts/15/videoeditor.aspx?action=create&referrer=OfficeHome&cid=").concat(componentContext.correlationId).concat(referrerParam);
                    }
                    else if (template && (identity === null || identity === void 0 ? void 0 : identity.isMsa)) {
                        url = "https://app.clipchamp.com/login/microsoft?content=".concat(template.AssetId, "&utm_source=harmony");
                    }
                    url = appendLoginHint(url || '', (identity === null || identity === void 0 ? void 0 : identity.loginHint) || '', (capabilities === null || capabilities === void 0 ? void 0 : capabilities.outgoingLoginHintEnabled) || false);
                    if (!url || !isValidUrl(url)) {
                        return [2 /*return*/, { type: "Error" /* CreateDocumentResultType.Error */ }];
                    }
                    return [4 /*yield*/, launchUrlWrapper(url, targetTab, newDocLinkTarget)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=createNewClipchamp.js.map